import React from 'react';

import Comment from "./Comment/Comment";

const Comments = ({commentData}) => {
    return (
        <div className="Comments">
            <table>
                {
                    commentData.map(comment => <Comment key={comment.commentId} {...comment}/>)
                }
            </table>
        </div>
    )
}

export default Comments;